export default "__VITE_ASSET__DfMl1R8I__"